import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { SortableTable } from 'components/UIElements'
import STRINGS from 'utils/strings'
import { generateUpdatedTable } from '../../utils/visitDayUtils'

const HEADER_OPTIONS = [
  { key: 'name', component: 'Visit Name', sortable: false },
  { key: 'visit_day', component: 'Study day', sortable: false, className: 'visit-day-col' },
]

const VisitSchedulePreviewTable = props => {
  const {
    filter,
    isEdit,
    selectedVisitScheduleId,
    studyVisitSchedule,
    visitScheduleInitialData,
    templateVisit,
    isNewVisitVersion,
    selectedCycleId,
  } = props

  const getAllCycles = () => {
    const arm = studyVisitSchedule?.find(item => item.id === selectedVisitScheduleId)
    return (
      arm?.phases?.reduce((acc, phase) => {
        return [...acc, ...phase?.cycles]
      }, []) ?? []
    )
  }

  const allCycles = getAllCycles()

  const rowList = useMemo(() => {
    if (!selectedVisitScheduleId) return []
    return generateUpdatedTable({
      templateVisit,
      initialVisits: visitScheduleInitialData[selectedVisitScheduleId]?.visitTableMap,
      isEdit,
      filter,
      allCycles,
      selectedCycleId,
      studyVisitSchedule,
      isNewVisitVersion,
    })
  }, [selectedVisitScheduleId, templateVisit, allCycles, selectedCycleId, isNewVisitVersion])

  return (
    <div className='visit-schedule-table-preview'>
      <label className='label-small' htmlFor='current-visit-schedule-table'>
        {isNewVisitVersion ? STRINGS.visitScheduleVisitsInARM : STRINGS.visitScheduleVisitsInSchedule}
      </label>
      <SortableTable
        emptyText={selectedVisitScheduleId ? 'Please add a visit' : 'Please select a visit schedule'}
        headerOptions={HEADER_OPTIONS}
        id='current-visit-schedule-table'
        rowList={rowList}
        sortingBy='visitDay'
      />
    </div>
  )
}

VisitSchedulePreviewTable.propTypes = {
  filter: PropTypes.shape(),
  isEdit: PropTypes.bool,
  selectedVisitScheduleId: PropTypes.string,
  templateVisit: PropTypes.shape(),
  visitScheduleInitialData: PropTypes.objectOf(PropTypes.object),
}

export default VisitSchedulePreviewTable
